import { useState } from "react";

interface LogoProps {
  className?: string;
  /** Clase para el contenedor del logo (img + fallback) */
  containerClassName?: string;
}

export function Logo({ className = "h-8 object-contain", containerClassName = "" }: LogoProps) {
  const [imgFailed, setImgFailed] = useState(false);
  return (
    <div className={containerClassName}>
      <img
        src="/logo-horizontal.png"
        alt="Circuit Cover Insurance"
        className={className}
        style={imgFailed ? { display: "none" } : undefined}
        onError={() => setImgFailed(true)}
      />
      {imgFailed && (
        <span className="text-[#2C2C2C] font-bold text-xl">
          circuitcover <span className="font-light">Insurance</span>
        </span>
      )}
    </div>
  );
}
